import * as React from "react";
import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {
  Button,
  Typography,
  Checkbox,
  FormGroup,
  TextField,
  Divider,
  Box,
  FormHelperText,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import DateObject from "react-date-object";
import gregorian from "react-date-object/calendars/gregorian";
import { myWordsQuery } from "../../../../../../validations/myWordsValidation";
// import LanguagesQuery from "./LanguagesQuery";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function TicketsListsQuery(props) {
  const { setQueryTicketsListData, getTicketsListFromBack } = props;
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [query, setQuery] = React.useState({
    status: "",
    ticketId: "",
    createdAt_start: "",
    createdAt_end: "",
  });

  const handleSetQueryValue = (key, value) => {
    const newValue = {};
    newValue[key] = value;
    setQuery({ ...query, ...newValue });
  };

  const initialValues = {
    status: "",
    ticketId: "",
    createdAt_start: "",
    createdAt_end: "",
  };

  const onSubmit = (values, props) => {
    let newValues = {
      status: values.status,
      ticketId: values.ticketId,
      createdAt_start: values.createdAt_start,
      createdAt_end: values.createdAt_end,
    };

    for (const property in newValues) {
      if (typeof newValues[property] == "boolean") continue;
      if (!newValues[property]) delete newValues[property];
    }
    setQueryTicketsListData(newValues);
    getTicketsListFromBack("getListTickets", newValues);
    // console.log("amir", newValues);
  };

  const handleSetFieldValues = (props, Field, data) => {
    props.setFieldValue(Field, data);
  };

  const handleDateTime = (date, props, Field) => {
    if (!date) {
      handleSetQueryValue(Field, "");
      handleSetFieldValues(props, Field, "");
    } else {
      date.convert(gregorian);
      let DateForSend = new DateObject({ date, calender: gregorian }).format(
        "YYYY-MM-DD"
      );
      handleSetFieldValues(props, Field, DateForSend);
      handleSetQueryValue(Field, DateForSend);
      date.convert(persian);
    }
  };
  const calenderDigits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={myWordsQuery}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "25%" : "50%" }}
                    ></StyledTableCell>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "75%" : "50%" }}
                    >
                      {" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"وضعیت"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormControl style={{ minWidth: 170 }}>
                        <InputLabel id="demo-simple-select-label">
                          وضعیت تیکت
                        </InputLabel>
                        <Select
                          size="small"
                          label="status"
                          name="status"
                          id="status"
                          value={query["status"]}
                          onChange={(e) => {
                            handleSetQueryValue("status", e.target.value);
                            handleSetFieldValues(
                              props,
                              "status",
                              e.target.value
                            );
                          }}
                        >
                          <MenuItem key={0} value={"openTicket"}>
                            باز
                          </MenuItem>
                          <MenuItem
                            autoFocus
                            key={1}
                            value="requestCloseTicket"
                          >
                            در انتظار بسته شدن
                          </MenuItem>
                          <MenuItem key={2} value={"closeTicket"}>
                            بسته
                          </MenuItem>
                          <MenuItem autoFocus key={3} value="answerByUser">
                            پاسخ داده شده توسط شما
                          </MenuItem>
                          <MenuItem autoFocus key={4} value="answerBySupoort">
                            پاسخ داده شده توسط مدیریت
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="status" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"شناسه تیکت"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="ticketId"
                        label="آی دی تیکت"
                        placeholder="آی دی تیکت"
                        value={query["ticketId"]}
                        onChange={(e) => {
                          handleSetQueryValue("ticketId", e.target.value);
                          handleSetFieldValues(
                            props,
                            "ticketId",
                            e.target.value
                          );
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="ticketId" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"(تاریخ درخواست) از تاریخ"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <DatePicker
                        digits={calenderDigits}
                        dateFormat="yyyy-MM-dd"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        // value={query["createdAt_start"]}
                        onChange={(e) => {
                          handleDateTime(e, props, "createdAt_start");
                        }}
                      />
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="createdAt_start" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"(تاریخ درخواست) تا تاریخ"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <DatePicker
                        digits={calenderDigits}
                        dateFormat="yyyy-MM-dd"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        // value={query["createdAt_end"]}
                        onChange={(e) => {
                          handleDateTime(e, props, "createdAt_end");
                        }}
                      />
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="createdAt_end" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 2 }}
              color="success"
            >
              جستجو
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
